/**
 * API service for favorites operations
 */

import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class FavoritesAPI {
    /**
     * Get user's favorites
     */
    static async getFavorites() {
        console.log(`❤️ FavoritesAPI: Getting favorites`);

        try {
            const headers = await getAuthHeaders();
            const response = await fetch(`${API_BASE_URL}/favorites`, {
                headers
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('NOT_AUTHENTICATED');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(`✅ FavoritesAPI: Got ${data.favorites?.length || 0} favorites`);
            return data;
        } catch (error) {
            console.error('❌ FavoritesAPI: Error getting favorites:', error);
            throw error;
        }
    }

    /**
     * Add item to favorites
     */
    static async addFavorite(product) {
        console.log(`➕ FavoritesAPI: Adding ${product.name} to favorites`);

        try {
            const headers = await getAuthHeaders({
                'Content-Type': 'application/json'
            });
            const response = await fetch(`${API_BASE_URL}/favorites`, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    product_id: String(product.id),
                    product_name: product.name,
                    product_price: product.price,
                    product_image: product.image
                })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('NOT_AUTHENTICATED');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(`✅ FavoritesAPI: Added to favorites`);
            return data;
        } catch (error) {
            console.error('❌ FavoritesAPI: Error adding favorite:', error);
            throw error;
        }
    }

    /**
     * Remove item from favorites
     */
    static async removeFavorite(productId) {
        console.log(`🗑️ FavoritesAPI: Removing ${productId} from favorites`);

        try {
            const headers = await getAuthHeaders();
            const response = await fetch(`${API_BASE_URL}/favorites/${productId}`, {
                method: 'DELETE',
                headers
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('NOT_AUTHENTICATED');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(`✅ FavoritesAPI: Removed from favorites`);
            return data;
        } catch (error) {
            console.error('❌ FavoritesAPI: Error removing favorite:', error);
            throw error;
        }
    }

    /**
     * Check if product is in favorites
     */
    static async checkFavorite(productId) {
        console.log(`🔍 FavoritesAPI: Checking if ${productId} is favorite`);

        try {
            const headers = await getAuthHeaders();
            const response = await fetch(`${API_BASE_URL}/favorites/check/${productId}`, {
                headers
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('NOT_AUTHENTICATED');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data.is_favorite;
        } catch (error) {
            console.error('❌ FavoritesAPI: Error checking favorite:', error);
            throw error;
        }
    }

    /**
     * Clear all favorites
     */
    static async clearFavorites() {
        console.log(`🗑️ FavoritesAPI: Clearing favorites`);

        try {
            const headers = await getAuthHeaders();
            const response = await fetch(`${API_BASE_URL}/favorites`, {
                method: 'DELETE',
                headers
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('NOT_AUTHENTICATED');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(`✅ FavoritesAPI: Favorites cleared`);
            return data;
        } catch (error) {
            console.error('❌ FavoritesAPI: Error clearing favorites:', error);
            throw error;
        }
    }
}

export default FavoritesAPI;
